import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const RELATIONSHIP_PATH = "/master/v1/reference-doctor";

export const getReferenceDoctorApi = async (params, options = {}) => await getRequest(RELATIONSHIP_PATH, params, options);

export const getReferenceDoctorByIdApi = async (id) =>
  await getRequest(`${RELATIONSHIP_PATH}/${id}`);

export const addReferenceDoctorApi = async (body) =>
  await postRequest(RELATIONSHIP_PATH, body);

export const updateReferenceDoctorApi = async (body) =>
  await putRequest(`${RELATIONSHIP_PATH}/${body?._id}`, body);

export const deleteReferenceDoctorByIdApi = async (id) =>
  await deleteRequest(`${RELATIONSHIP_PATH}/${id}`);
